import { Badge } from 'src/components/atoms';
import type { DefaultTheme } from 'styled-components';

export const getUserPermissionsLabels = (
  systemRoles: Array<{ id: string; label: string }>,
  theme: DefaultTheme,
) => {
  const systemRolesNames = systemRoles.map((systemRole) => systemRole.label);

  return systemRolesNames
    .filter((systemRole) => {
      if (
        // if user is both admin and super we display only super label
        systemRole === 'Admin' &&
        systemRolesNames.includes('Super Admin')
      ) {
        return false;
      }
      return true;
    })
    .map((systemRole) => {
      return createBadge(systemRole);
    });

  function createBadge(label: string) {
    return (
      <Badge
        key={label}
        data-testid={`Permission-${label.toUpperCase()}`}
        background-color={
          theme.isVaultVariant
            ? theme.newPalette.turquoise.T300
            : theme.atlas.semantic.color.surface.default
        }
        color={
          theme.isVaultVariant
            ? theme.newPalette.neutral.N0
            : theme.atlas.semantic.color.type.default
        }
        border-color={
          theme.isVaultVariant
            ? undefined
            : theme.atlas.semantic.color.outline.default
        }
        text={label}
        variant={'custom'}
      />
    );
  }
};
